import React from 'react';
import PropTypes from 'prop-types';
import contentTypeName from '../../utils/contentTypeName';
import SearchUserTeaser from './SearchUserTeaser';
import ContentTeaser from '../Global/Teasers/ContentTeaser';

const SearchList = ({ filterName, searchResults, limit, listItemClasses }) => (
  <ul className="search-list list-row row">
    {searchResults
      .filter(result => contentTypeName(result.type) === contentTypeName(filterName))
      .slice(0, limit)
      .map((result) => {
        // Allowing us to pass a React component as a prop to be rendered inside each list item
        let Teaser;
        let formattedProps;

        switch (result.type) {
          case `user`:
          case `club`:
          case `team`: {
            const { image_url, slug, title, the_real_deal, bio } = result;
            Teaser = SearchUserTeaser;
            formattedProps = {
              image: image_url,
              name: title,
              summary: bio,
              slug,
              verified: the_real_deal,
            };
            break;
          }

          default: {
            const { slug, title, type, summary, author_name, tcmAgeRange, usaAgeRange } = result;
            Teaser = ContentTeaser;
            formattedProps = {
              href: slug,
              title,
              summary,
              authorName: author_name,
              type,
              tcmAgeRange,
              usaAgeRange,
            };
          }
        }

        return (
          <li key={result.slug} className={`search-list__item d-flex ${listItemClasses}`}>
            <Teaser {...formattedProps} />
          </li>
        );
      })
    }
  </ul>
);

SearchList.propTypes = {
  filterName: PropTypes.string.isRequired,
  searchResults: PropTypes.array.isRequired,
  limit: PropTypes.number,
  listItemClasses: PropTypes.string,
};

export default SearchList;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchList.js